const labels = {
  All: { 'See the offering': 'Lásd az ajánlatot' },
  FacilityDetails: { 'Ref: Page title': 'Létesitmény részletek', 'Ref: Review': 'Felülvizsgálat' },
  FacilitiesList: { 'Ref: Page title': 'Létesítmények', 'Ref: See details': 'Lásd a részleteket' },
};
export default labels;
